import script from "./CreditReform.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditReform.vue?vue&type=script&setup=true&lang=js"

import "./CreditReform.vue?vue&type=style&index=0&id=09f34d08&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f34d08"]])

export default __exports__